import { DowngradeApi } from 'api-typings/memberships/memberships_types';
import { transformDuration } from '../membership-subscription-history/membership-subscription-history.transformers';
import { MembershipDowngrade } from './membership-downgrades.model';

export function transformMembershipDowngrades(
  membershipDowngrades: DowngradeApi,
): MembershipDowngrade {
  return {
    id: membershipDowngrades.id,
    timeCreated: membershipDowngrades.time_created * 1000,
    status: membershipDowngrades.status,
    packageId: membershipDowngrades.package_id,
    duration: transformDuration(membershipDowngrades.duration),
    failureCount: membershipDowngrades.failure_count,
    autoRenew: membershipDowngrades.auto_renew,
    periodId: membershipDowngrades.period_id,
    quantity: membershipDowngrades.quantity,
    isTrial: membershipDowngrades.is_trial || false,
    priceId: membershipDowngrades.price_id,
  };
}
